// extracted by mini-css-extract-plugin
export var mainIndex = "index-module--mainIndex--1Ty6e";
export var headerContainer = "index-module--headerContainer--1aoGn";
export var indexMessage = "index-module--indexMessage--17--O";